import React from "react";
import PropTypes from "prop-types";
import { styled, Checkbox, Grid, FormControlLabel } from "@mui/material";
import Tik from "../../assets/icons/Tik.svg";
import { PALETTE } from "../../Theme/Palette";

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: "0.4rem",
  width: "1.4rem",
  height: "1.4rem",
  backgroundColor: PALETTE.primary,
  border: "1px solid " + PALETTE.fourth,
  ".Mui-focusVisible &": {
    outline: "2px auto " + PALETTE.fourth,
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    backgroundColor: "#F1F1F0",
  },
  "input:disabled ~ &": {
    boxShadow: "none",
    background: PALETTE.fifth,
    border: "1px solid transparent",
  },
  "input:checked ~ &": {
    border: "1px solid transparent",
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  borderRadius: "0.4rem",
  backgroundImage: "linear-gradient(54.23deg, #E8447D 1.96%, #FB83AC 99.68%)",
  "&:before": {
    display: "block",
    width: "inherit",
    height: "inherit",
    backgroundImage: `url(${Tik})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "15% 60%",
    content: '""',
  },
  "input:disabled ~ &": {
    backgroundImage: "linear-gradient(54.23deg, #E8447D 1.96%, #FB83AC 99.68%)",
  },
});

function BaseCheckbox({ label, value = "", onChange = () => {}, ...props }) {
  const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
    bgColor: "#4C466F",
    borderRadius: "8px",
    fontSize: "14px",
    paddingRight: 0,
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&.Mui-checked": {
      color: " #E8447D",
    },
    "& svg": {
      backgroundColor: "red !important",
    },
  }));
  return (
    <Grid justifyContent="flex-end">
      <FormControlLabel
        value={value}
        control={<CustomCheckbox icon={<BpIcon />} checkedIcon={<BpCheckedIcon />} />}
        label={label}
        labelPlacement="start"
        sx={{
          fontSize: "10px",
          fontWeight: 300,
          textAlign: "right",
          "& .MuiFormControlLabel-label.Mui-disabled": {
            color: "#4C466F",
          },
        }}
        style={{
          color: "#4C466F",
        }}
        onChange={onChange}
        {...props}
      />
    </Grid>
  );
}

BaseCheckbox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func,
};

export default BaseCheckbox;
